<div class="truncated-container" [style.height]="currentHeight() || 'auto'">
  <div #content class="truncated-content">
    <ng-content />
  </div>

  @if (showButton()) {
    @if (currentHeight()) {
      <button
        mat-icon-button
        class="action-icon-button"
        (click)="setCurrentHeight('', $event)"
        aria-label="Expand bottom arrow icon">
        <mat-icon class="action-icon">keyboard_arrow_down</mat-icon>
      </button>
    } @else {
      <button
        mat-icon-button
        class="action-icon-button"
        (click)="setCurrentHeight(truncatedHeight(), $event)"
        aria-label="Expand bottom arrow icon">
        <mat-icon class="action-icon">keyboard_arrow_up</mat-icon>
      </button>
    }
  }
</div>
